import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SMCPage from '../../components/core/pageComponents/SMCPage';
import Api from '../../api/SMPFetchHelper';
import SMCIFrame from '../../components/Simple/SMCIFrame';
import {useSMCErrorHandler} from '../../utils/errorUtils';
import {currentPortalSelector} from '../../store/selectors/user.selectors';
import {addCookie} from '../../utils/cookies/cookies';
import {useCyberViewsDimensions} from '../../utils/hooks';
import {helpContextPageUrl} from '../../conf/Routes';

function GatewayLogs({
    currentPortal
}) {
    const { getErrorMessage } = useSMCErrorHandler();
    const [cyberViewsWidth, cyberViewsHeight] = useCyberViewsDimensions();

    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [smartviewUrl, setSmartviewUrl] = useState(null);
    
    useEffect(() => {
        Api.getSmartviewDataUrl(
            'logs',
            'service_domain',
            currentPortal,
            true,
            null,
            null,
            window.location.origin
        )
        .then(resp => {
            const respData = resp.data.data;
            const cookies = respData.cookieData;
            const url = respData.iframeSrcURL;
            
            const cookiePath = cookies.path;
            const smeId = cookies.SME_ID;
            const token = cookies.token;

            setSmartviewUrl(url);
            addCookie('SME_ID', smeId, cookiePath);
            addCookie('token', token, cookiePath);
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            alert(errorMessage);
        })
        .finally(() => {
            setIsPageLoaded(true);
        })
    }, [currentPortal, getErrorMessage]);



    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.attackTrends}>        
            {
                smartviewUrl && (
                    <SMCIFrame
                        style={{ width: cyberViewsWidth, height: cyberViewsHeight, border: '0 none' }}
                        src={smartviewUrl}
                        allowPopups
                        allowSameOrigin
                        allowScripts
                        allowDownloads
                    />
                )
            }
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    currentPortal: currentPortalSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(GatewayLogs);